import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { UserType } from "../types/UserType";
import { apiClient } from "src/utils/Api/apiClient";

interface userState {
        users: Array<UserType>;
        usersLoading: boolean;
        usersError: string | null;
}

const initialState: userState = {
        users: [],
        usersLoading: false,
        usersError: null
}

export const getUsersByDealerId = createAsyncThunk(
        'user/getUsersByDealerId,',
        async (userData: any, { rejectWithValue }) => {
                try {
                        const response = await apiClient.get(`user/getUsersByDealerId/${userData}`);
                        return response.data;
                } catch (userError: any) {
                        return rejectWithValue(userError.response.data || 'An error occured');
                }
        }
);

export const getUserById = createAsyncThunk(
        'user/getUserById,',
        async (userData: any, { rejectWithValue }) => {
                try {
                        const response = await apiClient.get(`user/getUserById/${userData}`);
                        return response.data;
                } catch (userError: any) {
                        return rejectWithValue(userError.response.data || 'An error occured');
                }
        }
);

export const getUsers = createAsyncThunk(
        'user/getUsers',
        async (userData: any, { rejectWithValue }) => {
                try {
                        const response = await apiClient.get('user/getUsers', userData);
                        return response.data;
                } catch (userError: any) {
                        return rejectWithValue(userError.response.data || 'An error occured');
                }
        }
);

const userSlice = createSlice({
        name: 'user',
        initialState,
        reducers: {
                reset: () => initialState,
        },
        extraReducers: (builder) => {
                //get all users from server
                builder.addCase(getUsers.pending, (state) => {
                        state.usersLoading = true;
                        state.usersError = null;
                });
                builder.addCase(getUsers.fulfilled, (state, action) => {
                        state.usersLoading = false;
                        state.users = action.payload;
                });
                builder.addCase(getUsers.rejected, (state, action) => {
                        state.usersLoading = false;
                        state.usersError = action.payload as string;
                });

                //get all users from server
                builder.addCase(getUserById.pending, (state) => {
                        state.usersLoading = true;
                        state.usersError = null;
                });
                builder.addCase(getUserById.fulfilled, (state, action) => {
                        state.usersLoading = false;
                        const id = action.payload.Id;
                        const index = state.users.findIndex(item => item.Id === id);
                        if (index !== -1) {
                                state.users[index] = action.payload;
                        }
                        else {
                                state.users.push(action.payload);
                        }
                });
                builder.addCase(getUserById.rejected, (state, action) => {
                        state.usersLoading = false;
                        state.usersError = action.payload as string;
                });

                //get users by Id from server
                builder.addCase(getUsersByDealerId.pending, (state) => {
                        state.usersLoading = true;
                        state.usersError = null;
                });
                builder.addCase(getUsersByDealerId.fulfilled, (state, action) => {
                        state.usersLoading = false;
                        state.users = action.payload;
                });
                builder.addCase(getUsersByDealerId.rejected, (state, action) => {
                        state.usersLoading = false;
                        state.usersError = action.payload as string;
                });

        }
});

export const { reset } = userSlice.actions;
export default userSlice.reducer;
